// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"4df4e063","2587":"61214666","3550":"5590196c","5140":"4df4e063","7249":"61214666","7739":"61214666","7841":"d49898dd","9704":"4df4e063","9727":"4df4e063","9969":"4df4e063"}[chunkId] + ".chunk.css";
};